import { motion } from "framer-motion";

/**
 * Animated SVG of a hand holding a pen that "signs" a contract line.
 * Pure SVG + framer-motion — no GIF, lightweight, theme-aware.
 */
const SigningHandAnimation = () => {
  return (
    <div
      className="relative w-full max-w-sm sm:max-w-md mx-auto lg:mx-0 mt-4 lg:mt-6 rounded-xl border border-border bg-card shadow-sm px-4 py-3 sm:px-5 sm:py-4"
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 360 120"
        className="w-full h-auto"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Paper / contract */}
        <rect
          x="10"
          y="20"
          width="340"
          height="90"
          rx="6"
          className="fill-card stroke-border"
          strokeWidth="1.5"
        />
        {/* Faint contract lines */}
        <line x1="25" y1="38" x2="240" y2="38" className="stroke-muted-foreground/30" strokeWidth="2" strokeLinecap="round" />
        <line x1="25" y1="52" x2="220" y2="52" className="stroke-muted-foreground/30" strokeWidth="2" strokeLinecap="round" />
        <line x1="25" y1="66" x2="200" y2="66" className="stroke-muted-foreground/30" strokeWidth="2" strokeLinecap="round" />

        {/* Signature line */}
        <line x1="25" y1="95" x2="250" y2="95" className="stroke-muted-foreground/50" strokeWidth="1" strokeDasharray="4 4" />

        {/* Animated signature stroke */}
        <motion.path
          d="M30 92 C 50 78, 70 104, 92 88 S 140 76, 165 92 S 210 80, 240 90"
          className="stroke-primary"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: [0, 1, 1, 0] }}
          transition={{
            duration: 5,
            times: [0, 0.55, 0.85, 1],
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Hand + pen group, follows the signature */}
        <motion.g
          initial={{ x: 0, y: 0 }}
          animate={{
            x: [0, 60, 120, 180, 220, 220, 0],
            y: [0, -6, 4, -4, 0, 0, 0],
          }}
          transition={{
            duration: 5,
            times: [0, 0.18, 0.36, 0.54, 0.7, 0.85, 1],
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          {/* Pen body */}
          <rect
            x="20"
            y="40"
            width="6"
            height="48"
            rx="2"
            transform="rotate(-30 23 64)"
            className="fill-primary"
          />
          {/* Pen tip */}
          <polygon
            points="30,90 36,94 32,98"
            className="fill-foreground"
          />
          {/* Hand (simple stylized) */}
          <ellipse
            cx="14"
            cy="46"
            rx="14"
            ry="10"
            transform="rotate(-30 14 46)"
            className="fill-accent/80 stroke-accent"
            strokeWidth="1"
          />
          {/* Cuff */}
          <rect
            x="-4"
            y="40"
            width="14"
            height="10"
            rx="2"
            transform="rotate(-30 3 45)"
            className="fill-primary/80"
          />
        </motion.g>
      </svg>
    </div>
  );
};

export default SigningHandAnimation;